/* eslint-disable max-len */
/**
 * Polish translations.
 */
export default {
  ACTION: {
    LINK_COPY: 'Kopia'
  },
  ERROR: {},
  HEADER: {
    NAME: 'Nazwa',
    PROFIT_MARGIN: 'Marża zysku'
  },
  LABEL: {
    GENERATE_LINK: 'Wygeneruj link',
    GENERATED_LINK: 'Wygenerowany link',
    NAME: 'Nazwa',
    PROFIT_MARGIN: 'Marża zysku'
  },
  SENTENCE: {},
  SUCCESS: {
    LINK_COPIED: 'Skopiowany link'
  },
  TOOLTIP: {
    NAME: 'Nazwa',
    PROFIT_MARGIN: 'Marża zysku'
  }
};
